module.exports = __webpack_public_path__ + "static/averta-regular-webfont-fdc2db2e017bdf4f5114f2d95a08745b.woff2";